import script from "./ImageGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&setup=true&lang=ts"

import "./ImageGallery.vue?vue&type=style&index=0&id=6e7dfdad&lang=postcss"

const __exports__ = script;

export default __exports__